export default __webpack_public_path__ + "static/media/Bank.316ac758.png";